import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchSharedModule } from '../shared/search-shared.module';
import { BrowseRoutingModule } from '@search/browse/browse-routing.module';
import { BrowsePage } from '@search/browse/browse.page';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { SearchBrowseCarouselComponent } from '@shared/components/search-browse-carousel/search-browse-carousel.component';
import { IonicModule } from '@ionic/angular';
import { BrowseCategoriesSkeletonComponent } from '@search/browse/component/browse-categories-skeleton/browse-categories-skeleton.component';
import { BrowseSharedModule } from '@search/browse/shared/browse-shared.module';
import { ZipCodeBannerComponent } from './component/zip-code-banner/zip-code-banner.component';
import { BrowseProductsComponent } from './component/browse-products/browse-products.component';
import { GuestBrowseProductsComponent } from './component/guest-browse-products/guest-browse-products.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SearchSharedModule,
    SharedModule,
    BrowseRoutingModule,
    IonicModule,
    BrowseSharedModule,
  ],
  declarations: [
    BrowsePage,
    SearchBrowseCarouselComponent,
    BrowseCategoriesSkeletonComponent,
    ZipCodeBannerComponent,
    BrowseProductsComponent,
    GuestBrowseProductsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BrowseModule {}
